export const EVIDENCE_EXPIRY_RULES = {
  annual:     { label: 'Annual',      days: 365 },
  biannual:   { label: 'Bi-Annual',   days: 180 },
  quarterly:  { label: 'Quarterly',   days: 90  },
  monthly:    { label: 'Monthly',     days: 30  },
  never:      { label: 'No Expiry',   days: null },
};

export const EVIDENCE_TYPES = [
  { value: 'policy',        label: 'Policy / Procedure' },
  { value: 'screenshot',    label: 'Screenshot / Config Proof' },
  { value: 'audit_report',  label: 'Audit Report' },
  { value: 'training',      label: 'Training Record' },
  { value: 'contract',      label: 'Contract / Agreement' },
  { value: 'scan',          label: 'Vulnerability Scan' },
  { value: 'log',           label: 'Log / Record' },
  { value: 'other',         label: 'Other' },
];

export function getExpiryDate(reviewFrequency, fromDate = new Date()) {
  const rule = EVIDENCE_EXPIRY_RULES[reviewFrequency];
  if (!rule || rule.days === null) return null;
  const d = new Date(fromDate);
  d.setDate(d.getDate() + rule.days);
  return d.toISOString().split('T')[0];
}

export function getDaysUntilExpiry(expiresAt) {
  if (!expiresAt) return null;
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const exp = new Date(expiresAt);
  exp.setHours(0, 0, 0, 0);
  return Math.floor((exp - now) / (1000 * 60 * 60 * 24));
}

export function getExpiryStatus(expiresAt) {
  const days = getDaysUntilExpiry(expiresAt);
  if (days === null) return 'none';
  if (days < 0)  return 'expired';
  if (days <= 7)  return 'critical';
  if (days <= 30) return 'warning';
  return 'ok';
}
